import { adminHttpClient } from "../../../commons/adminHttpClinet";
import { GetListOfWithdrawals, PaginatedWithdrawals } from "../../../models/dashboard/withdraw/withdraw";


const getWithdrawList = (model: GetListOfWithdrawals): Promise<PaginatedWithdrawals> => {
    return adminHttpClient.get(`/api/Admin/AdminMoveMoney/get-withdraws?PageNumber=${model.pageNumber}&PageSize=${model.pageSize}&SearchValue=${model.searchValue}&SortColumn=${model.sortColumn}&OrderDescending=${model.orderDescending}`)
}
export default getWithdrawList;